import { useState } from "react";
import { useNavigate } from "react-router-dom";
import searchBlack from "../images/searchBlack.svg"
import searchWhite from "../images/searchWhite.svg"
import { useDarkMode } from "../context/DarkModeContext";

const SearchBar = ({ translations }) => {
    const { darkMode } = useDarkMode();
    const navigate = useNavigate();
    const [value, setValue] = useState('');

    const submit = (e) => {
        e.preventDefault();
        const q = value.trim();
        if (q) navigate(`/search?q=${encodeURIComponent(q)}`);
    };

    return (
        <form className='nav-left' onSubmit={submit}>
            <input
                type="text"
                id="searchInput"
                className='search-bar'
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={translations['search-placeholder']}
            />
            <img
                id='search-navbar'
                src={darkMode ? searchWhite : searchBlack}
                alt="search"
                onClick={submit}
                style={{ cursor: 'pointer' }}
            />
        </form>
    )
}

export default SearchBar;
